import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'MainLoader',
  props: {
  primary: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader", { primary: __props.primary }])
  }, null, 2))
}
}

})